import React, { useMemo } from 'react';

import { NewsletterSubscription } from '@utils/backend-api/newsletters';
import { EmailSettings as EmailSettingsInterface } from '@utils/backend-api/settings';

import EmailSettingsOption from './EmailSettingsOption';
import {
  ARTICLE_NOTIFICATION_PROPS,
  ARTICLE_NOTIFICATION_STATUSES,
  WEEKLY_DIGEST_PROPS,
} from './constants';
import styles from './styles.module.scss';

interface EmailSettingsProps {
  newsletters: NewsletterSubscription[];
  userEmailSettings: EmailSettingsInterface;
  checkForConfirmationModal?: () => void;
}

const EmailSettings = ({
  newsletters,
  userEmailSettings,
  checkForConfirmationModal,
}: EmailSettingsProps) => {
  const emailSettings = useMemo(() => {
    const weeklyDigestSettings = {
      accessLevel: 2,
      isSubscribed: userEmailSettings?.weeklyDigestEmails,
      newsletterId: null,
      ...WEEKLY_DIGEST_PROPS,
    };

    const emailSettingOptions = [
      {
        accessLevel: 0,
        isSubscribed: ARTICLE_NOTIFICATION_STATUSES.includes(
          userEmailSettings.articleNotifications
        ),
        newsletterId: null,
        ...ARTICLE_NOTIFICATION_PROPS,
      },
      ...newsletters,
    ];

    if (userEmailSettings?.weeklyDigestEnabled) {
      emailSettingOptions.push(weeklyDigestSettings);
    }

    return emailSettingOptions;
  }, [
    newsletters,
    userEmailSettings.articleNotifications,
    userEmailSettings?.weeklyDigestEnabled,
    userEmailSettings?.weeklyDigestEmails,
  ]);

  return (
    <div className={styles.emailOptionContainer}>
      {emailSettings.map((option) => (
        <EmailSettingsOption
          key={option.subheader}
          checkForConfirmationModal={checkForConfirmationModal}
          {...option}
        />
      ))}
    </div>
  );
};

export default EmailSettings;
